import { UserApi } from '../../../common/constants/user-api';
import { getResponseData } from '../../../common/utils/api-utils';
import { getAppFlow } from '../utils/user-profile.util';

export const getUserDepartments = async ({ countryCode }) => {
  const url = new URL(UserApi.getDepartments(countryCode));
  return await getResponseData(
    new Request(url.toString(), {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Flow': getAppFlow()
      },
    })
  );
};
